wbApp.factory('compensationsSvc', ['$resource', 'repositorySvc',
    function ($resource, repositorySvc) {

        var Compensations = $resource('/Api/CompensationSummary/GetAll', {}, {
            'query': { method: 'GET', isArray: true },
            'getDetail': { method: 'GET', isArray: true, url: '/Api/CompensationSummary/GetDetail' },
        });

        function getAllAsync(semesterID) {
            return repositorySvc.get(Compensations, { semesterID: semesterID });
        }

        function getDetailAsync(semesterID, studentID) {
            return repositorySvc.customGet('getDetail', Compensations, {
                semesterID: semesterID,
                studentID: studentID
            });
        }

        return {
            getAllAsync: getAllAsync,
            getDetailAsync: getDetailAsync
        }
    }]);